import LoadingTextRoot, { Props } from './LoadingText'

export default function LoadingText(props: Props) {
  return <LoadingTextRoot {...props} />
}

export type { Props } from './LoadingText'
